import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState } from '@/modules/allies/dailyCut/store/dailyCutSlice/initialState.ts'
import { DailyCutCashOutDetail } from '@/modules/services/dailyCut/types/DailyCutCashOutDetail.ts'

const dailyCutSlice = createSlice({
  name: 'dailyCut',
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<string>) => {
      state.filters = action.payload
    },
    setSelectedAllyId: (state, action: PayloadAction<string>) => {
      state.selectedAllyId = action.payload
    },
    setSelectedRows: (
      state,
      action: PayloadAction<DailyCutCashOutDetail[]>
    ) => {
      state.selectedRows = action.payload
    },
    setOpenProcesarPagoModal: (state, action: PayloadAction<boolean>) => {
      state.isProcesarPagoModalOpen = action.payload
    },
    setPayAmountModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isPayAmountModalOpen = action.payload
    },
    reset: () => initialState
  }
})

export const dailyCutActions = dailyCutSlice.actions
export const { reducer: dailyCutReducer } = dailyCutSlice
